import React from "react";
import "./LandingPage.css";
import Header from "./Common/Header";
import Footer from "./Common/Footer";
import AboutPage from "./Pages/AboutPage";



const App = () => {
  return (
    <>
   <Header/>
    {/* <!-- Hero Section --> */}
    <div className="container">
      <section className="hero-section">
        <div className="hero-content">
          <h1>
            Smart CRM & ERP for the Next<br className="hide-on-desktop" />
            Generation of Business
          </h1>
          <p>
            Manage leads, automate workflows, and grow faster with Sess — your
            all-in-one business management platform.
          </p>
          <a href="#" className="demo-btn">Demo →</a>
        </div>
      </section>

      {/* <!-- Business Management --> */}
      <section className="business-management">
        <div className="section-header">
          <h2>Say Hello to Simpler, Smarter Business Management</h2>
          <p>
            Build lasting customer relationships with a powerful, all-in-one CRM
            solution.
          </p>
        </div>

        <div className="cards-container">
          <div className="card">
            <div className="card-header">Manage Your Leads</div>
            <img
              src="images/Screenshot1.png"
              alt="Manage Leads"
              className="card-image"
            />
            <div className="card-content">
              <h3>Leads</h3>
              <p>
                Track, capture, and convert potential customers efficiently with
                smart lead automation. <a href="#">Read More...</a>
              </p>
            </div>
          </div>

          <div className="card">
            <div className="card-header">Manage Your Tasks</div>
            <img
              src="images/Screenshot2.png"
              alt="Manage Tasks"
              className="card-image"
            />
            <div className="card-content">
              <h3>Tasks</h3>
              <p>
                Organize, assign, and track tasks in real-time to boost your
                team’s productivity and accountability.
                <a href="#">Read More...</a>
              </p>
            </div>
          </div>

          <div className="card">
            <div className="card-header">Manage Your Tickets</div>
            <img
              src="images/Screenshot2.png"
              alt="Manage Tickets"
              className="card-image"
            />
            <div className="card-content">
              <h3>Ticket</h3>
              <p>
                Streamline customer support with organized ticket tracking,
                quick resolutions, and real-time updates.
                <a href="#">Read More...</a>
              </p>
            </div>
          </div>
        </div>

        <div className="cta-wrapper">
          <a href="#" className="cta-button"
            >Get Started Free <img src="./images/arrow-big-right.png" alt=""
          /></a>
        </div>
      </section>

      <section className="why-sess">
        <div className="content-wrapper">
          <h2>🤝 Why Choose Sess?</h2>
          <p>
            Sess is your all-in-one platform for managing and growing your
            business efficiently. From advanced CRM and ERP solutions to
            powerful campaign tools, email automation, lead tracking, and ticket
            management — everything is built to streamline your operations and
            boost productivity. With Sess, you get a complete suite to manage
            contacts, teams, workflows, and customer support — all from one
            intuitive dashboard.
          </p>
          <div className="button-group">
            <a href="#" className="btn contact"
              >Contact Now <img src="./images/phone.png" alt=""
            /></a>
            <a href="#" className="btn btn-primary">Get Started Now</a>
          </div>
        </div>
      </section>

      <section className="erp-management">
        <div className="erp-wrapper">
          <h2>ERP Management</h2>

          <div className="erp-cards-container">
            {/* <!-- Card 1 --> */}
            <div className="erp-card">
              <img
                src="images/erp-1.png"
                alt="Invoice Features"
                className="erp-img"
              />
              <h3>Invoice Features</h3>
              <ul>
                <li>✔️ <span>Flexible Taxation</span></li>
                <li>✔️ <span>Easy Invoice Creation</span></li>
                <li>✔️ <span>Invoice Reports & Analytics</span></li>
              </ul>
              <p>
                Simplify your billing process with Sess’s smart invoice
                management system. Create, send, and track invoices effortlessly
                — all in one place.
              </p>
            </div>

            {/* <!-- Card 2 --> */}
            <div className="erp-card">
              <img src="images/erp-2.png" alt="Clients" className="erp-img" />
              <h3>Clients</h3>
              <ul>
                <li>✔️ <span>Multi Profile</span></li>
                <li>✔️ <span>Easy management</span></li>
                <li>✔️ <span>Clients Reports & Analytics</span></li>
              </ul>
              <p>
                Simplify your billing process with Sess’s smart invoice
                management system. Create, send, and track invoices effortlessly
                — all in one place.
              </p>
            </div>

            {/* <!-- Card 3 --> */}
            <div className="erp-card">
              <img src="images/erp-3.png" alt="Dashboard" className="erp-img" />
              <h3>Dashboard</h3>
              <ul>
                <li>✔️ <span>Multi Profile</span></li>
                <li>✔️ <span>Easy Invoice Creation</span></li>
                <li>✔️ <span>Invoice Reports & Analytics</span></li>
              </ul>
              <p>
                Simplify your billing process with Sess’s smart invoice
                management system. Create, send, and track invoices effortlessly
                — all in one place.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- Testimonials --> */}
      <section className="testimonials">
        <h2 className="testimonials-title">TestiMonials</h2>

        <div className="testimonial-wrapper">
          <button className="arrow left">←</button>

          <div className="testimonial-card">
            <img
              src="images/Avatar1.png"
              alt="Isabella Moretti"
              className="avatar"
            />
            <h3 className="name">Isabella Moretti</h3>
            <p className="quote">
              “With Sess, our task and ticket workflows are more organized than
              ever. The intuitive dashboard keeps everyone on the same page.”
            </p>
          </div>

          <div className="testimonial-card">
            <img src="images/Avatar2.png" alt="James Carter" className="avatar" />
            <h3 className="name">James Carter</h3>
            <p className="quote">
              “Sess has streamlined our entire sales pipeline. Managing leads
              and follow-ups has never been this efficient — it’s a game-changer
              for our team.”
            </p>
          </div>

          <div className="testimonial-card">
            <img src="images/Avatar3.png" alt="Lars Andersen" className="avatar" />
            <h3 className="name">Lars Andersen</h3>
            <p className="quote">
              “The campaign and email automation tools are fantastic. We’ve seen
              a significant boost in engagement and response rates since
              switching to Sess.”
            </p>
          </div>

          <button className="arrow right">→</button>
        </div>
      </section>
      {/* <!-- customer-support --> */}
      <section className="customer-support">
        <h2>Customer Support By Sess</h2>

        <div className="support-cards">
          <div className="support-card">
            <img
              src="images/support-card-1.png"
              alt="Secure & Reliable Support"
            />
            <span>Secure & Reliable Support</span>
          </div>

          <div className="support-card">
            <img src="images/support-card-2.png" alt="Quick Response Times" />
            <span>Quick Response Times</span>
          </div>

          <div className="support-card">
            <img
              src="images/support-card-3.png"
              alt="Track Your Support Tickets"
            />
            <span>Track Your Support Tickets</span>
          </div>

          <div className="support-card">
            <img src="images/support-card-4.png" alt="Email Notifications" />
            <span>Email Notifications</span>
          </div>
        </div>

        <p className="support-description">
          Deliver exceptional service with Sess’s integrated customer support
          system
        </p>
      </section>

      {/* <!-- cta section  --> */}

      <section className="cta-section">
        <div className="cta-content">
          <div className="cta-text">
            <p>
              Ready to grow your business with smarter <br />
              CRM & ERP? Start your free trial today — no <br />
              credit card required.
            </p>
            <div className="cta-buttons">
              <a href="#" className="btn btn-primary">Get Started Now</a>
              <a href="#" className="btn contact"
                >Contact Now <img src="./images/phone.png" alt=""
              /></a>
            </div>
          </div>

          <div className="cta-image">
            <img src="images/cta-right.png" alt="Team Illustration" />
          </div>
        </div>
      </section>
    </div>
    {/* <!-- Footer --> */}
<Footer/>
   
    </>
  );
};


export default App;
